import { required, optional } from 'AppReact/schema';

export default {
  effective_rent: optional('number'),
  floor_plan: required('string'),
  make_ready_date: optional('date'),
  market_rent: optional('number'),
  number: required('string'),
  occupancy: required('string'),
  status: required('string'),
  vacate_date: optional('date')
};
